// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 530 ? "page" : chunkId) + "." + {"84":"cbbec569","530":"60421e1f","789":"8fe48baf","815":"8fe48baf"}[chunkId] + ".css";
};